import { RESET_STATE, REGISTER_USER, REGISTER_USER_SUCCESS, REGISTER_USER_FAIL } from './actionTypes';

export const registerUser = (payload) => {
    return {
        type: REGISTER_USER,
        payload: payload
    }
}

export const registerUserSuccessful = (payload) => {
 return {
        type: REGISTER_USER_SUCCESS,
        payload: payload
    }
}

export const registerUserFail = (payload) => {
 return {
        type: REGISTER_USER_FAIL,
        payload: payload
    }
}

export const resetRegisterState = () => {
    return {
         type: RESET_STATE
    }
}


